import { useEffect, useState } from "react";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import getSchema from "../../lib/api/getSchema";
import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import DeleteRecordButton from "../input/DeleteRecordButton";
import { debounce } from 'lodash';
import { useSetRecoilState } from "recoil";
import notificationState from "../../states/notificationState";
import TkProcessTempleteCreateButton from "../input/TkProcessTempleteCreateButton";
import TkProcessTempleteUpdateButton from "../input/TkProcessTempleteUpdateButton";

function TkProcessTemplete ( props ) {

    const id = "TkProcessTemplete";

    const [schema, setSchema] = useState();

    const [isEmpty, setIsEmpty ] = useState();

    const [grid, setGrid] = useState();

    const [ api, setApi ] = useState ();

    const [onSelect, setOnSelect] = useState();

    const setNotification = useSetRecoilState(notificationState);

    useEffect ( () => {

        let mounted = true;

        (async () => {

            let schema = await getSchema("TkProcessTemplete");

            if ( mounted ) {

                setSchema(schema);
    
            }
    
        } ) ();

        return ( () => {
            mounted = false;
        } );

    }, [] );

    useEffect(() => {

        ( async () => {

            if (grid) {
    
                grid.selectionChanged.addHandler(debounce((grid, event) => {

                    if ( grid.selectedItems && grid.selectedItems[0] ) {

                        setOnSelect(grid.selectedItems[0])

                    } else {

                        setOnSelect([]);

                    };

                }, 10));
    
                grid.itemsSourceChanged.addHandler(debounce((grid, event) => {

                    if ( grid.selectedItems && grid.selectedItems[0] ) {

                        setOnSelect(grid.selectedItems[0])

                    } else {

                        setOnSelect([]);

                    };

                }, 10));

            }

        } ) ()

    }, [grid] )

    const onLoadData = (data) => {

        let isEmpty = data.length < 1 ? true : false;

        setIsEmpty(isEmpty);


    };

    const onInitialized = grid => {

        // grid.selectionMode = "Row";

        setGrid(grid);

    };

    const onApiInitialized = ( api ) => {

        setApi ( api );

    };

    const notifySuccess = (msg) => {

        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
        
    };

    const onSuccess = ( msg ) => {
    
        notifySuccess ( msg );
    
    };

    const notifyFailure = (msg) => {
    
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
        
    };

    const onFailure = ( reason ) => {
    
        notifyFailure ( reason.response ? reason.response.data : reason );
    
    };

    const notifyWarning = (msg) => {

        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });

    };

    const onNotifyWarning = ( msg ) => {

        notifyWarning ( msg );

    };

    const onAppendButtonInFrontOfSearch = () => {

        return (

            <BasicCrudScreenActionItemLayout>

                <TkProcessTempleteCreateButton
                    id={id}
                    schema = {schema}
                    onSuccess = {onSuccess}
                    api = {api}
                    
                />
                <TkProcessTempleteUpdateButton
                    id={id}
                    schema = {schema}
                    grid= {grid}
                    onSelect = {onSelect}
                    disabled={isEmpty}
                    onSuccess = {onSuccess}
                    api = {api}
                />

                <DeleteRecordButton
                    id={id}
                    schema={schema}
                    grid={grid}
                    refresh={api}
                    color="secondary"
                    disabled={isEmpty}
                    onSuccess={onSuccess}
                    onFailure={onFailure}
                    onPartialFailure={onNotifyWarning}
                />

            </BasicCrudScreenActionItemLayout>
        )

    };

    return(
        <BasicCrudScreenType
            id= {id}
            table="TkProcessTemplete" 
            view="TkVwProcessTemplete"
            onLoadData = {onLoadData}
            onInitialized = {onInitialized}
            onApiInitialized = {onApiInitialized}
            onAppendButtonInFrontOfSearch={onAppendButtonInFrontOfSearch}
            noCreate
            noEdit
            noDelete
            noExcel
        />

    )

}

export default TkProcessTemplete;
